import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se encacarga de obtener listados de sedes vinculadas o no a un programa académico
//ProgramId: identificador del programa
//Dsc: Descripión
//UserId: id usuario logueado
//CompanyId: Identificador de la compañía
//AccionPeticionValidar: Permisos de usuario para realizar la operación
export const ListadoSedes = (filtros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/ProgramasSedes/Listado', filtros).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para vincular o desvincular una sede de un programa académico 
//ProgramId: identificador del programa
//CampusId: Identificador de la sede
//UserId: id usuario logueado
//CompanyId: Identificador de la compañía
//AccionPeticionValidar: Permisos de usuario para realizar la operación
export const ActualizarSedes = (programa) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/ProgramasSedes/Actualizar", programa).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se encacarga de obtener listados de sedes vinculadas de un programa académico
//ProgramId: identificador del programa
//UserId: id usuario logueado
//CompanyId: Identificador de la compañía
export const ListadoSedesVinculadas = (programa) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/ProgramasSedes/ListadoVinculado', programa).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};